import {RootDesc} from "@ui/descriptions/RootDesc";
import {DropCalendar} from "@ui/general/DropCalendar";
import moment from "moment";
import {useTranslation} from "react-i18next";

import styles from "./styles.module.scss";

export const DropRangeCalendar = (props) => {
  const {
    minDate = moment().subtract(1, "years").toDate(),
    fromDate = new Date(),
    setFromDate,
    toDate = new Date(),
    setToDate,
    monthYearOnly = false,
  } = props;

  const {t} = useTranslation();

  const handleChangeFromDate = (currentDate) => {
    setFromDate(currentDate);
  };

  const handleChangeToDate = (currentDate) => {
    setToDate(currentDate);
  };

  return (
    <div className={styles.chartsCalendars}>
      <div className={styles.chartsCalendarsHead}>
        <RootDesc>
          <span>{t("input.select_date_from")}</span>
        </RootDesc>

        <DropCalendar
          format={"DD MMMM YYYY"}
          minDate={minDate}
          date={fromDate}
          setDate={handleChangeFromDate}
          monthYearOnly={monthYearOnly}
          isFrom
        />
      </div>
      <div className={styles.chartsCalendarsHead}>
        <RootDesc>
          <span>{t("input.select_date_to")}</span>
        </RootDesc>

        <DropCalendar
          format={"DD MMMM YYYY"}
          minDate={minDate}
          date={toDate}
          setDate={handleChangeToDate}
          monthYearOnly={monthYearOnly}
          isFrom={false}
        />
      </div>
    </div>
  );
};
